module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/companies/Company.ejs -->\n';
 var moment = require('moment') 
__p+='\n<td>\n    ';
 if (model.get('isLocked')) { 
__p+='\n        <i class="fa fa-exclamation-triangle"\n            data-toggle="tooltip"\n            data-placement="top" data-container="body"\n            data-title="this company has been locked due to payment overdue"\n        ></i>\n    ';
 } 
__p+='\n    '+
((__t=( model.get('companyName') ))==null?'':_.escape(__t))+
'\n</td>\n<td>'+
((__t=( model.get('contactName') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('contactEmail') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('lastActiveTime') ? moment(model.get('lastActiveTime'))
            .format('DD.MM.YYYY HH:mm') : '' ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( moment(model.get('createdAt')).format('DD.MM.YYYY') ))==null?'':_.escape(__t))+
'</td>\n<td>\n    ';

       if (subscription) {
           var matchingCoupon = discountCodes.find(
               function (code) { return code.id === subscription.get('couponCode'); }
            );
    
__p+='\n    <div class="discount-inputs '+
((__t=( model.get('mppAdminId') ? 'hidden' : '' ))==null?'':_.escape(__t))+
'">\n        <input name="discount"\n            list="couponCode" style="width:120px"\n            value="'+
((__t=( matchingCoupon ? matchingCoupon.invoice_name || matchingCoupon.name : '' ))==null?'':_.escape(__t))+
'"\n        >\n        <datalist id="couponCode">\n        ';
 discountCodes.forEach(function (discountCode) { 
__p+='\n            <option value="'+
((__t=( discountCode.invoice_name || discountCode.name ))==null?'':_.escape(__t))+
'">\n        ';
 }); 
__p+='\n        </datalist>\n        &nbsp;\n        <input name="isDiscountLimited" type="checkbox"\n            '+
((__t=( subscription.get('isDiscountLimited') ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n        > Limit\n        <input name="discountLimit" type="number" class="steps"\n            style="width:50px"\n            placeholder="Number of free invoices entitled to"\n            value="'+
((__t=( subscription.get('discountLimit') || 0 ))==null?'':_.escape(__t))+
'"\n            max="100" min="0" step="1"\n        >\n        <a class="js-discount-save" href="#">\n            <i class="fa fa-save"></i>\n        </a>\n    </div>\n    ';
 } 
__p+='\n</td>\n<td class="flex-container-row" style="overflow: visible;">\n    <a href="" class="spaced-child js-login-to-company" title="Login to Company">\n        <i class="fa fa-2x fa-sign-in"></i>\n    </a>\n    <a class="spaced-child" href="/#payrolls/'+
((__t=( model.id ))==null?'':_.escape(__t))+
'" title="Payrolls">\n        <i class="fa fa-2x fa-info"></i>\n    </a>\n    <a class="spaced-child" href="/#logs/'+
((__t=( model.id ))==null?'':_.escape(__t))+
'" title="Log">\n        <i class="fa fa-2x fa-list-alt"></i>\n    </a>\n    <a class="spaced-child" href="/#employees/'+
((__t=( model.id ))==null?'':_.escape(__t))+
'" title="Employees">\n        <i class="fa fa-2x fa-users"></i>\n    </a>\n    <a href="" title="Remove account" class="spaced-child js-remove-company">\n        <i class="fa fa-2x fa-trash"></i>\n    </a>\n    ';
 if (subscription) {  
__p+='\n    <div class="btn-group spaced-child" style="overflow: visible;">\n        <button type="button" class="btn btn-default dropdown-toggle"\n                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n            Subscription<span class="caret"></span>\n        </button>\n        <ul class="dropdown-menu">\n            <li><a href="#"\n                   title="Update subscription status according to invoices from\n                          Chargebee"\n                   class="js-update-subs">Update Subscription Status</a></li>\n            <li><a href="#"\n                   title="Update customer details"\n                   class="js-update-details">Update Customer Details</a>\n            </li>\n            <li><a href="#"\n                   title="Adjust yearly subscription"\n                   class="js-yearly-adjust">Adjust Yearly Subscription</a>\n            </li>\n        </ul>\n    </div>\n    ';
 } 
__p+='\n</td>\n<td>\n    <select class="form-control js-ext js-ext-mppAdmin" name="mppAdmin">\n        <option value=""></option>\n        ';
 mppAdmins.forEach(function(user) { 
__p+='\n            <option value="'+
((__t=( user.id ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( (model.get('mppAdminId') === user.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( user.get('name') ))==null?'':_.escape(__t))+
'\n            </option>\n        ';
 }) 
__p+='\n    </select>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/companies/Company.ejs
// module id = 657
// module chunks = 1